import router from "./router";
import store from "../store/store";
const commonlyRouters = [
  'VideoSurveillance', 'VideoManage', 'home'
]
let loadAsyncRouter = false
router.beforeEach((to, from, next) => {
  if (to.name === 'login') {
    store.dispatch('systemLoginOut').then(() => {
      next()
    })
  }
  else if (to.name === '/403' || to.name === '/404'  || to.name === 'Login') {
    next()
  } else {
    if (!loadAsyncRouter) {  // 判断当前用户是否获取权限
      store.commit('SET_USERINFO', JSON.parse(localStorage.getItem('userInfo')))
      loadAsyncRouter = true
      if (filterRouter(to.name)) {
        next(filterRouter(to.name))
      } else {
        next()
      }
    } else {
      if (filterRouter(to.name)) {
        next(filterRouter(to.name))
      } else {
        next()
      }
    }
  }
})

function filterRouter (path) {
  const userInfo = store.state.user.userInfo
  if (userInfo === null) {
    return 'login'
  } else {
    if (userInfo.job === '一般人员') {
      if (commonlyRouters.indexOf(path) === -1) {
        return '/403'
      } else {
        return false
      }
    } else {
      return false
    }
  }

}
